import { render, staticRenderFns } from "./smarttablequestion.vue?vue&type=template&id=347dbb50&scoped=true"
import script from "./smarttablequestion.vue?vue&type=script&lang=js"
export * from "./smarttablequestion.vue?vue&type=script&lang=js"
import style0 from "./smarttablequestion.vue?vue&type=style&index=0&id=347dbb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347dbb50",
  null
  
)

export default component.exports